// GENERATED by scripts/build-icons.mjs from icons/plug.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Plug = createIcon('plug', [
  ['path', { d: "M12 22v-5" }],
  ['path', { d: "M15 8V2" }],
  ['path', { d: "M17 8a1 1 0 0 1 1 1v4a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1z" }],
  ['path', { d: "M9 8V2" }],
])
